// src/components/modals/WriteInModal.js
import React from 'react';
import Modal from '../shared/Modal';
import Button from '../shared/Button';
import WriteInCounter from '../common/WriteInCounter';
import './WriteInModal.css';

/**
 * Modal for creating custom white cards
 */
function WriteInModal({
  show,
  onClose,
  writeInText,
  setWriteInText,
  onCreateCard,
  writeInStats,
  writeInLimits,
  blackCardPickCount,
}) {
  // Check if user can create more write-ins
  // Use actual limit based on black card pick count
  const actualLimit = blackCardPickCount || writeInStats?.perRound?.limit || 3;
  const used = writeInStats?.perRound?.used || 0;
  const canCreate = writeInStats && used < actualLimit && !writeInStats.cooldown.active;

  const footer = (
    <>
      <Button variant="secondary" onClick={onClose}>
        Cancel
      </Button>
      <Button
        variant="primary"
        onClick={onCreateCard}
        disabled={!writeInText.trim() || !canCreate}
        title={
          !canCreate
            ? writeInStats?.cooldown.active
              ? `Wait ${writeInStats.cooldown.remaining}s`
              : 'Write-in limit reached'
            : ''
        }
      >
        Create Card
      </Button>
    </>
  );

  return (
    <Modal
      show={show}
      onClose={onClose}
      title="✍️ Write Custom Card"
      footer={footer}
      size="md"
      contentClassName="write-in-modal"
    >
      {/* Rate limiting counter */}
      {writeInStats && writeInLimits && (
        <WriteInCounter
          stats={writeInStats}
          limits={writeInLimits}
          blackCardPickCount={blackCardPickCount}
        />
      )}

      <p>Create your own answer card response (max 200 characters):</p>
      <textarea
        value={writeInText}
        onChange={(e) => setWriteInText(e.target.value)}
        placeholder="Enter your custom response..."
        maxLength={200}
        className="write-in-textarea"
        autoFocus
        disabled={!canCreate}
      />
      <div className="character-count">{writeInText.length}/200 characters</div>
    </Modal>
  );
}

export default WriteInModal;
